import { useToast } from '@pelckmans/elementis/components/toast';
import { useTranslation } from 'react-i18next';
import { TOAST_ID } from '../constants/ToastIds';

export function useDefaultToast() {
  const { addToast } = useToast();
  const { t } = useTranslation();

  const failedToast = () =>
    addToast({
      id: TOAST_ID.DEFAULT_ERROR,
      title: t('TOAST.DANGER.TITLE'),
      children: t('TOAST.DANGER.MESSAGE'),
      variant: 'danger',
    });

  const successToast = () =>
    addToast({
      id: TOAST_ID.DEFAULT_SUCCESS,
      title: t('TOAST.SUCCESS.TITLE'),
      children: t('TOAST.SUCCESS.MESSAGE'),
      variant: 'success',
    });

  return { failedToast, successToast };
}
